import { Owner } from 'utils/customTypes';
import UserAvatar from 'Atoms/UserAvatar';
import { PROGRAMS_STATUS } from 'utils/constants';
import intl from 'react-intl-universal';
import get from 'lodash/get';
import { AvatarGroup, tailwindOverride, Tag } from '@getsynapse/design-system';
import { isUserStatusDisabled } from 'utils/functions';
import { DeletedUser } from 'Atoms/DeletedUser';

export const getOwnersCell = (owners: Owner[]) => {
  if (owners.length === 0) {
    return <DeletedUser content={intl.get('OWNER_REQUIRED')} />;
  }
  if (owners.length === 1) {
    return (
      <div className='flex items-center'>
        <UserAvatar
          user={{
            avatar_url: owners[0].avatar_url,
            data: {
              firstName: get(owners[0], 'data.firstName'),
              lastName: get(owners[0], 'data.lastName'),
            },
            status: owners[0].status,
          }}
          className='mr-2.5'
        />
        {`${get(owners, '0.data.firstName')} ${get(owners, '0.data.lastName')}`}
      </div>
    );
  } else {
    return (
      // deactivatedText belongs on AvatarGroup, not on the individual avatars:
      // the group overrides each avatar's value with its own, which defaults to
      // a hardcoded English "Deactivated".
      <AvatarGroup
        deactivatedText={intl.get('DEACTIVATED')}
        avatars={owners.map((owner) => {
          const firstName = get(owner, 'data.firstName');
          const lastName = get(owner, 'data.lastName');
          return {
            size: 'medium',
            imageSrc: owner.avatar_url,
            initial: get(firstName, '[0]'),
            name: `${firstName} ${lastName}`,
            disabled: isUserStatusDisabled(owner.status),
          };
        })}
      />
    );
  }
};

export const getProgramStatusPill = (status: string, isEditable?: boolean) => {
  const statusMapping = {
    [PROGRAMS_STATUS.NOT_STARTED]: {
      bgColor: 'bg-purple-lightest',
      textColor: 'text-purple-darker',
    },
    [PROGRAMS_STATUS.IN_PROGRESS]: {
      bgColor: 'bg-teal-lightest',
      textColor: 'text-teal-dark',
    },
    [PROGRAMS_STATUS.CLOSED]: {
      bgColor: 'bg-warning-lightest',
      textColor: 'text-warning-darker',
    },
  };

  const colorAndLabel = statusMapping[status];

  return (
    <Tag
      className={tailwindOverride(
        `text-xs border border-transparent py-0.5 ${get(
          colorAndLabel,
          'bgColor',
          ''
        )}`,
        {
          'cursor-pointer': isEditable,
        }
      )}
      textClassName={get(colorAndLabel, 'textColor', '')}
      label={intl
        .get(`PROGRAMS_LIST_PAGE.STATUS.${status.toUpperCase()}`)
        .defaultMessage('')}
    />
  );
};
